/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'container',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M48,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C56,207.582,52.418,204,48,204

      M96,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C104,207.582,100.418,204,96,204

      M144,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C152,207.582,148.418,204,144,204

      M192,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C200,207.582,196.418,204,192,204

      M240,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C248,207.582,244.418,204,240,204

      M288,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C296,207.582,292.418,204,288,204

      M336,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C344,207.582,340.418,204,336,204

      M384,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C392,207.582,388.418,204,384,204

      M432,204c-4.418,0-8,3.582-8,8v112c0,4.418,3.582,8,8,8s8-3.582,8-8V212C440,207.582,436.418,204,432,204

      M440,140h-32c-4.418,0-8,3.582-8,8s3.582,8,8,8h32c4.418,0,8-3.582,8-8S444.418,140,440,140

      M72,140H40c-4.418,0-8,3.582-8,8s3.582,8,8,8h32c4.418,0,8-3.582,8-8S76.418,140,72,140

      M456,84c-13.255,0-24,10.745-24,24v8H48v-8c0-13.255-10.745-24-24-24S0,94.745,0,108v280c0,4.418,3.582,8,8,8h464
			c4.418,0,8-3.582,8-8V108C480,94.745,469.255,84,456,84z M16,108c0-4.418,3.582-8,8-8s8,3.582,8,8v8H16V108z M144,380H16v-16h128
			V380z M192,380h-32v-16h32V380z M272,380h-64v-16h64V380z M320,380h-32v-16h32V380z M464,380H336v-16h128V380z M464,348H16V188
			h448V348z M464,172H16v-40h448V172z M464,116h-16v-8c0-4.418,3.582-8,8-8s8,3.582,8,8V116
      
      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/container.js